export enum PraDuration {
  ONE_YEAR = 1,
  TWO_YEARS = 2,
  THREE_YEARS = 3,
}
